module.exports = __webpack_public_path__ + "static/media/daymaker-led-headlamp.33560023.jpg";